import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { If, Then, Else } from "react-if";
import { DatePicker, Steps, TimePicker } from "antd";
import { Select as FormikSelect } from "formik-antd";
import moment from "moment";
import Checkbox from "antd/lib/checkbox/Checkbox";

import {
  uploadBroadCastFileNewAction,
  broadCastMessageAction,
  broadCastMessageReviewAction,
  broadCastPatientListAction,
  removeBroadCastApiPatientAction,
  broadCastApiPatientListAction,
  broadCastProvidersListAction,
  cancelMessageAction,
} from "../../../../sagas/saga-broadcast";
import loginService from "../../../../service/login";
import UserService from "../../../../service/UserService";
import CommonService from "../../../../service/CommonService";
import CustomLabel from "../../../../components/customLabel";
import CheckboxSelect from "../../../../components/checkboxSelect";
import CustomButton from "../../../../components/customButton";
import LoadingSpinner from "../../../../components/loadingSpinner";
import BroadcastMessage from "../BroadcastMessage/BroadcastMessage";
import InitiateBroadcast from "../InitiateBroadcast/initiateBroadcast";
import { SERVER_ERR } from "../../../../constants/messages";
import { setPopup } from "../../../../actions/popupAction";
import CustomNotification from "../../../../components/notification";
import BroadcastService from "../../../../service/BroadcastUserService";
import NoInternetAction from "../../../../actions/noInternetAction";
import { Switch, Tooltip } from "antd";
import { ErrorYellowIcon, MultiLanguageInfoIcon} from "../../../../assets/svg";
import "./styles.scss";
import { getFormData } from "../../../../helper/helpers";
import {
  ATHENA_EHR,
  EPIC_EHR,
  NEXTGEN_EHR,
  NEXTGEN_EHR_WHITELABEL,
  PRACTICE_EDITION_WHITELABEL,
  EPIC_EHR_WHITELABEL,
  NO_SHOW_LABEL,
} from "../../../../constants/constants";
import { TEXT_LABELS } from "../../../../constants/textLabels";
import BottomBar from "../../../../components/bottomBar";
import CustomInput from "../../../../components/customInput";
import { SingleFormikSelect } from "../../../../components/select/singleSelect";
import MobileHeader from "../../../../components/header/mobileHeader";
const IS_NON_PROD = !process.env.REACT_APP_ENV?.endsWith("prod"); 

const { Step } = Steps;

const getFlattenedSelected = (selectionState) =>
  Object.keys(selectionState?.selected || {}).reduce(
    (selectedRows, page) =>
      selectedRows.concat(selectionState.selected[page] || []),
    [],
  );

const apiEhrs = [NEXTGEN_EHR, ATHENA_EHR];
const FilterBroadcast = (props) => {
  const userService = new UserService();
  const commonservice = new CommonService();
  const broadcastService = new BroadcastService();
  const { RangePicker } = DatePicker;
  const { Option } = FormikSelect;
  const steps = [
    {
      title: "First",
      content: "Search Appointments",
    },
    {
      title: "Second",
      content: "Broadcast Message",
    },
    {
      title: "Last",
      content: "Review Broadcast Details",
    },
  ];
  const [current, setCurrent] = useState(0);
  const next = () => {
    if (current === 1) {
      // to Validate selection before proceeding
      if (state.selectionState.allSelected) {
        setCurrent(current + 1);
      } else {
        const selectedIds = getFlattenedSelected(state.selectionState);
        if (selectedIds.length > 0) {
          setCurrent(current + 1);
        } else {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: "Please select at least one appointment",
          });
        }
      }
    } else {
      setCurrent(current + 1);
    }
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const isEpicEhr = props?.user?.practice?.ehrName.toLowerCase() === EPIC_EHR;
  const initialState = {
    broadcastIds: null,
    clickedSearch: false,
    isTwilioDisabled: localStorage.getItem("isTwilioDisabled_appointment") === "true",
    allowDuplicate: localStorage.getItem("allowDuplicate_appointment") === "true",
    data: [],
    department: [],
    status: [],
    departmentId: null,
    ehrName: null,
    endDate: null,
    errorMessage: null,
    file: undefined,
    fileId: "",
    fileName: "",
    filterData: [],
    filterText: null,
    headers: [],
    loading: true,
    provider: { data: [] },
    resource: { data: [] },
    providerType: "all",
    providerId: null,
    resourceId: null,
    showtable: false,
    startDate: null,
    tableHeader: [],
    triggerStartClick: false,
    convoType: "sms",
    broadcastInitiated: false,
    notConfigured: true,
    selectionState: {
      selected: {},
      unselected: [],
      allSelected: false,
    },
    pageNo: 1,
    filteredCount: 0,
    searchKey: "",
    searchValue: "",
    initialValues: {
      fileBasedSearchType:
        isEpicEhr && EPIC_EHR_WHITELABEL ? "Reminder Workflow" : "API",
      selectResources: false,
      date: "",
      departmentId: [],
      appointmentStatus: [],
      status: [],
      providerList: [],
      time: "",
      providerId: "",
      nxtgnDepartment: "",
    },
  };

  const [state, setState] = useState(initialState);

  const patientLookupSchema = Yup.object().shape({
    date: Yup.array()
      .required("Date is required")
      .nullable(),
    departmentId:
      state.ehrName?.toLowerCase() !== NEXTGEN_EHR &&
      Yup.array()
        .test(
          "departmentId",
          `${TEXT_LABELS.departmentLabelText}s are required`,
          (value, obj) => {
            return (
              (value && value.length > 0) ||
              obj.parent.fileBasedSearchType != "API"
            );
          },
        )
        .required(`${TEXT_LABELS.departmentLabelText}s are required`),
    nxtgnDepartment:
      state.ehrName?.toLowerCase() === NEXTGEN_EHR &&
      Yup.string().test(
        "test-integration",
        "Department is required",
        (val, obj) => {
          return obj.parent.fileBasedSearchType != "API" || val;
        },
      ),
    time:
      state.ehrName?.toLowerCase() !== EPIC_EHR &&
      state.ehrName?.toLowerCase() !== ATHENA_EHR &&
      state.ehrName?.toLowerCase() !== NEXTGEN_EHR &&
      Yup.array()
        .test("time", "Time is required", (value, obj) => {
          return (
            (value && value.length > 0) ||
            obj.parent.fileBasedSearchType != "API"
          );
        })
        .nullable(),
  });
   const handleTwilioDisabledToggle = (checked) => {
  try {
    localStorage.setItem("isTwilioDisabled_appointment", String(checked));
  } catch (e) {
    console.log(e);
  }
  setState((st) => ({ ...st, isTwilioDisabled: checked }));
};
const handleAllowDuplicateToggle = (checked) => {
  try {
    localStorage.setItem("allowDuplicate_appointment", String(checked));
  } catch (e) {
    console.log(e);
  }
  setState((st) => ({ ...st, allowDuplicate: checked }));
};

  const checkAppointmentData = async () => {
    try {
      const checkConfigurationExists = await commonservice.fetchAppointmentData();

      if (!PRACTICE_EDITION_WHITELABEL && !checkConfigurationExists) {
        setState((st) => ({
          ...st,
          notConfigured: false,
          errorMessage:
            "Please add configurations for your account to fetch appointments",
          clickedSearch: false,
        }));
      } else {
        getAppointmentData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getAppointmentData = () => {
    try {
      props.broadCastApiPatientList({}, (status, response) => {
        const { data, count } = response || {};

        if (status && data && data.length) {
          const tableHeader = JSON.parse(data[0].headers);
          // tableHeader.splice(
          //   tableHeader.findIndex((item) => item.Header === "id"),
          //   1
          // );

          const fields = data.map((item) => ({
            id: item.id,
            fileId: item.fileId,
            fileName: item?.fileName,
            ...JSON.parse(item.fields),
          }));

          const broadcastIds = data.map((item) => item.id);

          setState((st) => ({
            ...st,
            broadcastIds: broadcastIds,
            fileId: data[0] ? data[0].fileId : "",
            fileName: data?.[0]?.fileName,
            clickedSearch: true,
            tableHeader,
            data: fields,
            filterKey: tableHeader && tableHeader[0].accessor,
            showtable: true,
            headers: tableHeader,
            loading: false,
            count,
            filteredCount: count,
          }));
          // Search success should always land on the results step.
          // Reusing the generic next-step handler can incorrectly trigger
          // the "select at least one appointment" validation when the
          // component is already on step 1.
          setCurrent((prev) => (prev < 1 ? 1 : prev));
        }
      });

      setState((st) => ({
        ...st,
        loading: false,
      }));
    } catch (e) {
      setState((st) => ({
        ...st,
        loading: false,
      }));
    }
  };

  const handleSubmit = async (values) => {
    props.noInternetAction();
    if (!props.noInternet.noInternetMessage) {
      try {
        setState((st) => ({
          ...st,
          loading: true,
        }));
        const isEpic = state.ehrName?.toLowerCase() === EPIC_EHR;
        const isAthena = state.ehrName?.toLowerCase() === ATHENA_EHR;
        const isNextgen = state.ehrName?.toLowerCase() === NEXTGEN_EHR;

        const isReminderWorkflow =
          values.fileBasedSearchType === "Reminder Workflow";

        let departmentIdPayload = "";

        //NEXTGEN
        if (isNextgen) {
          if (isReminderWorkflow) {
            // nxtgnDepartment holds departmentId, convert to id
            const dept = state.department.find(
              (d) => d.departmentId === values.nxtgnDepartment,
            );
            departmentIdPayload = dept?.id || "";
          } else {
            // existing NEXTGEN behavior
            departmentIdPayload = values.nxtgnDepartment;
          }
        }
        //NON-NEXTGEN
        else {
          if (isReminderWorkflow) {
            departmentIdPayload = state.department
              .filter((d) => values.departmentId.includes(d.departmentId))
              .map((d) => d.id)
              .join(",");
            const selectedDepartments = state.department.filter((d) =>
              values.departmentId.includes(d.departmentId),
            );
            const ids = selectedDepartments.map((d) => d.id).join(",");
            const deptIds = selectedDepartments
              .map((d) => d.departmentId)
              .join(",");
            departmentIdPayload = `${ids}|${deptIds}`;
          } else {
            departmentIdPayload = values.departmentId.join(",");
          }
        }

        const data = {
          startDate:
            isEpic || isNextgen || isAthena
              ? new Date(values.date[0]).toISOString().substr(0, 10)
              : getDateTime(values.date[0], values.time[0]),
          ...((isNextgen || isAthena || isEpic) &&
            values?.time?.length === 2 && {
              startTime: moment(values.time[0]).format("HHmm"),
            }),
          endDate:
            isEpic || isNextgen || isAthena
              ? new Date(values.date[1]).toISOString().substr(0, 10)
              : getDateTime(values.date[1], values.time[1]),
          ...((isNextgen || isAthena || isEpic) &&
            values?.time?.length === 2 && {
              endTime: moment(values.time[1]).format("HHmm"),
            }),
          departmentId: departmentIdPayload,
          ...(values.providerId
            ? { providerId: values.providerId.toString() }
            : {}),
          ...(values.resource
            ? { resourceId: values.resource.value.toString() }
            : {}),
          integrationType:
            values.fileBasedSearchType === "API"
              ? "api"
              : values.fileBasedSearchType === "File Based"
                ? "file"
                : values.fileBasedSearchType === "Reminder Workflow"
                  ? "reminderworkflow"
                  : "api",
          appointmentStatus: values.appointmentStatus,
          status: values.status,
          providerList: values.providerList,
          allowDuplicate: state.allowDuplicate,
        };
        const patients =
          state.ehrName?.toLowerCase() === EPIC_EHR
            ? await userService.getPatients(data)
            : await userService.getAppointmentList(data);

        const tableHeader = [...patients.data.headers];
        if (tableHeader.length) {
          // tableHeader.splice(
          //   tableHeader.findIndex((item) => item.Header === "id"),
          //   1
          // );

          setState((st) => ({
            ...st,
            errorMessage: null,
            clickedSearch: true,
            fileId: patients?.data?.fileId,
            fileName: patients?.data?.fileName,
          }));
        } else {
          setState((st) => ({
            ...st,
            errorMessage: "No data found in below selection.",
            clickedSearch: false,
          }));
          props.setPopup({
            customPopupMessage: true,
            message: "No data found in below selection.",
            messageType: "info",
          });
        }

        setState((st) => ({
          ...st,
          tableHeader,
          showtable: false,
          headers: tableHeader,
          loading: true,
        }));

        getAppointmentData();
      } catch (error) {
        setState((st) => ({
          ...st,
          loading: false,
        }));

        props.setPopup({
          customPopupMessage: true,
          message: error.response?.data?.message
            ? error.response?.data?.message
            : SERVER_ERR,
          messageType: "error",
          loading: false,
        });
      }
    } else {
      props.setPopup({
        customPopupMessage: true,
        message: props.noInternet.noInternetMessage,
        messageType: "error",
        loading: false,
      });
    }
  };

  const broadcastMessage = (message) => {
    props.noInternetAction();

    if (!props.noInternet.noInternetMessage) {
      const selectedIds = getFlattenedSelected(state.selectionState);

      if (!state.selectionState.allSelected && selectedIds.length === 0) {
        props.setPopup({
          customPopupMessage: true,
          message: "Please select at least one appointment.",
          messageType: "error",
        });
        return;
      }

      setState((st) => ({
        ...st,
        loading: true,
      }));

      const { user } = props;
      const { data, broadcastIds } = state;

      const practiceId = loginService.getPracticeId();

      const broadcastObj = {
        practiceId,
        fileId: data && data[0].fileId,
        filename: state.filename,
        emailSubject: message.emailSubject,
        emailColumn: message.emailColumn,
        emailTemplateId: message.emailTemplateId,
        message: message,
        userId: user.id,
        broadcastIds: selectedIds,
        userType: "apiPatient",
        convoType: message.convoType,
        ivrMessage: message.ivrMessage,
        ivrTemplate: message.ivrTemplate,
        useSmsForIVR: message.useSmsForIVR,
        optOutMessage: message.optOutMessage,
        optOutTemplate: message.optOutTemplate,
        enableOptOut: message.enableOptOut,
        responseTemplate: message.responseTemplate,
        responseMessage: message.responseMessage,
        selectAll: state.selectionState.allSelected,
        selectedCount: state.selectionState.allSelected
          ? state.filteredCount - state.selectionState.unselected.length
          : selectedIds.length,
        filter: state.searchValue,
        unselectedIds: state.selectionState.unselected,
        subtype:
          message.convoType === "ivr" && message.subtype ? "audio" : "text",
        isTwilioDisabled: IS_NON_PROD 
         ? state.isTwilioDisabled  
         : localStorage.getItem("isTwilioDisabled_appointment") === "true",
        countryCodeForRcs: localStorage.getItem("countryCodeForRcs") || "",
       allowDuplicate: state.allowDuplicate,
      };

      const payloadData = {
        body: JSON.stringify(broadcastObj),
        audio: message.audio,
      };
      const formData = getFormData(payloadData);

      props.broadCastMessage(formData, (status, msg) => {
        if (status) {
          props.setPopup({
            customPopupMessage: true,
            message:
              "Broadcast has been initiated successfully, please check report for status",
            messageType: "success",
          });

          setState((st) => ({
            ...st,
            loading: false,
            broadcastInitiated: true,
            selectionState: {
              selected: {},
              unselected: [],
              allSelected: false,
            },
          }));
        } else {
          setState((st) => ({ ...st, loading: false }));

          props.setPopup({
            customPopupMessage: true,
            message: msg,
            messageType: "error",
          });
        }
      });
    } else {
      props.setPopup({
        customPopupMessage: true,
        message: props.noInternet.noInternetMessage,
        messageType: "error",
      });
    }
  };

  const cancel = () => {
    setState((st) => ({ ...st, loading: true }));
    props.removeBroadCastApiPatient({ fileId: state.fileId }, (status) => {
      setState((st) => ({
        ...st,
        file: undefined,
        filterText: "",
        filterKey: "",
        filterData: [],
        showtable: false,
        data: [],
        clickedSearch: false,
        date: null,
        departmentId: null,
        providerId: null,
        resourceId: null,
        time: null,
        nxtgnDepartment: null,
        loading: false,
        selectionState: {
          selected: {},
          unselected: [],
          allSelected: false,
        },
      }));
      setCurrent(0);
    });
  };

  const handleResend = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: false,
      file: undefined,
      showtable: false,
      clickedSearch: false,
      date: null,
      departmentId: null,
      providerId: null,
      resourceId: null,
      time: null,
      nxtgnDepartment: null,
      selectionState: {
        selected: {},
        unselected: [],
        allSelected: false,
      },
      pageNo: 1,
      filteredCount: 0,
      searchKey: "",
      searchValue: "",
    }));
  };

  const hideInitiateBroadcast = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: false,
    }));
  };
  const rowKey = (row) => {
    return row["id"] || row[(state.headers?.[0]?.accessor)];
  };

  const fetchTableData = (filters) => {
    return new Promise((resolve, reject) => {
      const { order: sortBy, search, page, ...others } = filters;
      const filter = search ? encodeURIComponent(JSON.stringify(search)) : "";
      const filterChanged = state.searchValue !== filter;

      setState((st) => ({
        ...st,
        searchKey: search && Object.keys(search)[0],
        searchValue: search && JSON.stringify(search),
        pageNo: page,
        ...(filterChanged
          ? {
              selectionState: {
                allSelected: false,
                selected: {},
                unselected: [],
              },
            }
          : {}),
      }));
      props.broadCastApiPatientList(
        { ...others, filter, sortBy, page },
        (status, response) => {
          const { data, count } = response || {};
          if (status && data && data.length) {
            const fields = data.map((item) => ({
              id: item.id,
              ...JSON.parse(item.fields),
            }));
            setState((st) => ({
              ...st,
              selectionState:
                st.selectionState.allSelected &&
                !st.selectionState.selected[page]
                  ? {
                      ...st.selectionState,
                      selected: {
                        ...st.selectionState.selected,
                        [page]: fields.map((row) => row.id),
                      },
                    }
                  : st.selectionState,
              fields,
              filteredCount: count,
            }));
            resolve({ rows: fields, count });
          }
          resolve({ rows: [], count: 0 });
        },
      );
    });
  };

  const getSuggestions = async (column, value) => {
    const data = await broadcastService.getSuggestionsAppointment(
      column,
      value,
    );
    return data || [];
  };

  const getScheduledMsgData = (message) => {
    const { data } = state;
    const selectedIds = getFlattenedSelected(state.selectionState);

    const objdata = {
      fileId: data && data[0].fileId,
      fileName: data?.[0]?.fileName,
      message: message,
      broadcastIds: selectedIds,
      userType: "apiPatient",
      convoType: message.convoType,
      selectAll: state.selectionState.allSelected,
      selectedCount: state.selectionState.allSelected
        ? state.filteredCount - state.selectionState.unselected.length
        : selectedIds.length,
      filter: state.searchValue,
      unselectedIds: state.selectionState.unselected,
    };

    return objdata;
  };

  const showBroadcastResend = () => {
    setState((st) => ({
      ...st,
      broadcastInitiated: true,
      loading: false,
      selectionState: {
        selected: {},
        unselected: [],
        allSelected: false,
      },
      pageNo: 1,
      filteredCount: 0,
      searchKey: "",
      searchValue: "",
    }));
  };

  const handleParentLoading = (loading = true) => {
    setState((st) => ({
      ...st,
      loading,
    }));
  };

  const checkInitialData = async () => {
    const ehrName = loginService.getEhrName();
    try {
      await checkAppointmentData();

      setState((st) => ({
        ...st,
        loading: true,
      }));
      const practiceId = loginService.getPracticeId();
      const department = await userService.getDepartment(practiceId);
      department.data.map(
        (department) =>
          (department.name = `${department.name} | ${
            department?.departmentId
          }`),
      );
      let provider = { data: [] };
      setState((st) => ({
        ...st,
        department: department && department.data,
        ehrName,
      }));

      if (PRACTICE_EDITION_WHITELABEL) {
        const statusList = await broadcastService.getStatusList(practiceId);
        setState((st) => ({
          ...st,
          status: statusList && statusList.rows,
        }));
      }

      if (ehrName?.toLowerCase() !== NEXTGEN_EHR) {
        try {
          setState((st) => ({ ...st, loading: true }));
          const result = await userService.getProviders({
            providerType: state.providerType,
          });
          setState((st) => ({ ...st, loading: false }));
          if (result && Array.isArray(result.data)) {
            provider = result;
          }
        } catch (e) {
          setState((st) => ({ ...st, loading: false }));
        }
      }
      if (ehrName?.toLowerCase() === NEXTGEN_EHR) {
        fetchResources();
      }
      setState((st) => ({
        ...st,
        provider,
        loading: false,
      }));
    } catch (e) {
      setState((st) => ({
        ...st,
        ehrName,
        loading: false,
      }));
      props.setPopup({
        customPopupMessage: true,
        message:
          e?.response?.data?.message?.replace(/[^a-zA-Z0-9\s-]/g, "") ||
          e?.message?.replace(/[^a-zA-Z0-9\s-]/g, "") ||
          SERVER_ERR,
        messageType: "error",
        loading: false,
      });
    }
  };

  useEffect(
    () => {
      // this is done to get initial data (eg. departments, providers, etc for step 1)
      if (current === 0) {
        checkInitialData();
      }
    },
    [current],
  );

  const { data, loading, showtable, headers, count } = state;
  const { customPopupMessage, messageType, message } = props.popupReducer;

  const formattedDepartmentList =
    state.department &&
    state.department.map((list) => {
      return {
        title:
          state.ehrName?.toLowerCase() !== ATHENA_EHR
            ? list.name
            : list.departmentInternalName,
        key: list.departmentId,
        value: list.departmentId,
        id: list.id,
      };
    });

  // Appointment status options come from the API
  // (api/v1/pe/appointments/calendar/suggestions/status -> { rows: [{ id, label }] }),
  // stored in state.status. value is the id so the selection (values.status) is a
  // list of ids that gets sent on submit.
  const formattedStatusList =
    (Array.isArray(state.status) &&
      state.status
        .filter((item) => item?.label !== NO_SHOW_LABEL)
        .map((item) => ({
          title: item.label,
          key: item.id,
          value: item.id,
        }))) ||
    [];

  const formattedProviderList =
    state.provider &&
    state.provider.data.map((provider) => {
      return {
        title: `${provider.firstName + " " + provider.lastName}`,
        key: `${provider.firstName + " " + provider.lastName}`,
        value: provider.id,
      };
    });

  const isDateDisabledForReminderWorkflow = (currentDate) => {
    const today = moment().startOf("day");
    const minDate = today.clone().subtract(30, "days");
    // Disable dates before minDate (30 days ago), allow all future dates
    return currentDate < minDate;
  };

  const formattedResourceList =
    state.resource &&
    state.resource.data.map((resource) => {
      return {
        title: resource.name,
        key: resource.name,
        value: resource.id,
      };
    });

  const getDateTime = (date, time) => {
    const dateTime = moment(
      date.format("YYYY/MM/DD") + " " + time.format("HH:mm"),
    );
    return dateTime.toISOString();
  };

  const backButtonClicked = () => {
    switch (current) {
      case 0:
        props.handleBackButton();
        return;
      case 1:
        cancel();
        return;
      case 2:
        if (!state.broadcastInitiated) {
          prev();
        } else {
          props.handleBackButton();
        }
        return;
      case 3:
        prev();
        return;
      default:
        return;
    }
  };

  const filterProviderList = async (e, type) => {
    e.stopPropagation();
    const provider = await userService.getProviders({ providerType: type });
    setState((st) => ({
      ...st,
      provider,
      providerType: type,
    }));
  };

  const fetchProviders = (page = 1, searchQuery) => {
    return new Promise(async (resolve, reject) => {
      try {
        const provider = await userService.getProviders(
          {
            providerType: state.providerType,
          },
          searchQuery,
        );
        setState((st) => ({
          ...st,
          provider,
        }));
        resolve(1);
      } catch (err) {
        reject(err);
      }
    });
  };

  const fetchResources = (page = 1, searchQuery) => {
    return new Promise(async (resolve, reject) => {
      try {
        const resource = await userService.getResources({}, searchQuery);
        setState((st) => ({
          ...st,
          resource,
        }));
        resolve(1);
      } catch (err) {
        reject(err);
      }
    });
  };

  return (
    <>
      {/* Loader */}
      {state.loading && <LoadingSpinner customClassName="broadcast" />}

      {/* Header */}
      <div className="header-bar-mob">
        <MobileHeader
          showLogo={false}
          showNotifications={false}
          showHelp={false}
          showAccountDetails={false}
          showBackButton={true}
          showPageTitle={true}
          pageTitle="New Broadcast"
          handleBackButton={backButtonClicked}
          backgroundColor={
            NEXTGEN_EHR_WHITELABEL || PRACTICE_EDITION_WHITELABEL
              ? "black-bg"
              : ""
          }
        />
      </div>

      {/* Stepper */}
      <div className="stepper">
        <Steps
          current={current}
          direction="horizontal"
          responsive={false}
          size="small"
        >
          {steps.map((item) => (
            <Step key={item.title} />
          ))}
        </Steps>
      </div>

      {/* <button onClick={()=>next()}>Next</button> */}

      {/* Notification */}
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      {/* TODO */}
      <If condition={state.broadcastInitiated}>
        <Then>
          <InitiateBroadcast
            heading="Broadcast Initiated"
            hideMessage={hideInitiateBroadcast}
            handleResend={handleResend}
            history={props.history}
          />
        </Then>
      </If>

      {/* step 1 => as soon as appointments page is loaded */}
      {!state.clickedSearch ? (
        <>
          <Formik
            enableReinitialize
            initialValues={state.initialValues}
            validationSchema={patientLookupSchema}
            onSubmit={(values, actions) => {
              handleSubmit(values);
            }}
          >
            {({
              touched,
              dirty,
              errors,
              isValid,
              values,
              setFieldValue,
              setFieldTouched,
            }) => {
              const resetProvider = () => {
                setFieldValue("provider", null);
                setFieldValue("providerId", null);
              };

              const ButtonComponent = () => (
                <div className="provider-options">
                  <CustomButton
                    className={`button-styling ${
                      state.providerType === "all" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      resetProvider();
                      filterProviderList(e, "all");
                    }}
                    title="All"
                  />
                  <CustomButton
                    className={`button-styling ${
                      state.providerType === "rendering" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      resetProvider();
                      filterProviderList(e, "rendering");
                    }}
                    title="Rendering"
                  />
                  <CustomButton
                    className={`button-styling ${
                      state.providerType === "referring" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      resetProvider();
                      filterProviderList(e, "referring");
                    }}
                    title="Referrals"
                  />
                </div>
              );

              return (
                <>
                  <If condition={state.errorMessage}>
                    <Then>
                      <section className="no-appointments-message">
                        <span className="message">
                          {ErrorYellowIcon} {state.errorMessage}
                        </span>
                      </section>
                    </Then>
                  </If>
                  <div
                    className="appointments-main-container"
                    data-testid="appointments-page-wrapper"
                  >
                    <Form
                      className="fields-wrapper appointments-message-form"
                      id="appointments-message-form"
                    >
                      <h2 className="heading desktop-version">
                        Search available appointments for broadcast message
                      </h2>

                      <h2 className="heading mobile-version">
                        Search Appointments
                      </h2>

                      <p className="sub-heading mobile-version">
                        Search available appointments for broadcast message
                      </p>

                      <article className="form-fields-wrapper">
                        {!PRACTICE_EDITION_WHITELABEL && (
                          <section className="form-row with-mutli-select custom-form-row">
                            <CustomLabel title="Search" />
                            <FormikSelect
                              name="fileBasedSearchType"
                              className="common-select-field"
                              placeholder="Select Search Type"
                              style={{ width: 310 }}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                              value={values.fileBasedSearchType}
                              onChange={(value) => {
                                setFieldValue("fileBasedSearchType", value);
                                setFieldValue("date", "");
                                setFieldValue("time", "");
                                setFieldValue("departmentId", []);
                                setFieldValue("provider", null);
                                setFieldValue("providerId", null);
                                setFieldValue("resource", null);
                                // Reset fields as needed
                                if (value === "File Based") {
                                  setFieldValue("selectResources", false);
                                  setFieldValue("resource", null);
                                }
                              }}
                              disabled={
                                state.ehrName?.toLowerCase() !== EPIC_EHR
                              }
                              allowClear={false}
                            >
                              <Option value="API">API</Option>
                              <Option value="File Based">File Based</Option>
                              {isEpicEhr &&
                                EPIC_EHR_WHITELABEL && (
                                  <Option value="Reminder Workflow">
                                    Reminder Workflow
                                  </Option>
                                )}
                            </FormikSelect>
                          </section>
                        )}

                        <section className="form-row with-mutli-select custom-form-row">
                          <CustomLabel
                            required={values.fileBasedSearchType === "API"}
                            title={TEXT_LABELS.departmentLabelText}
                          />
                          <If
                            condition={
                              state.ehrName?.toLowerCase() !== NEXTGEN_EHR
                            }
                          >
                            <Then>
                              <CheckboxSelect
                                disabled={!state.notConfigured && true}
                                data={formattedDepartmentList}
                                placeholder={`Select ${
                                  TEXT_LABELS.departmentLabelText
                                }s`}
                                customClass={
                                  touched.departmentId && errors.departmentId
                                    ? "error-box"
                                    : ""
                                }
                                name="departmentId"
                                value={values.departmentId}
                                onChange={(value) =>
                                  setFieldValue("departmentId", value)
                                }
                                onBlur={() =>
                                  setFieldTouched("departmentId", true)
                                }
                              />
                              {touched.departmentId && errors.departmentId ? (
                                <div className="error-label">
                                  {errors.departmentId}
                                </div>
                              ) : null}
                            </Then>
                            <Else>
                              <FormikSelect
                                name="nxtgnDepartment"
                                className={`common-select-field ${
                                  touched.nxtgnDepartment &&
                                  errors.nxtgnDepartment
                                    ? "error-box"
                                    : ""
                                }`}
                                placeholder={`Select ${
                                  TEXT_LABELS.departmentLabelText
                                }s`}
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                style={{ width: 310 }}
                                disabled={!state.notConfigured && true}
                                onChange={(value) => {
                                  setFieldValue("nxtgnDepartment", value);
                                }}
                              >
                                {formattedDepartmentList.map((item) => (
                                  <Option key={item.value} value={item.value}>
                                    {item.title}
                                  </Option>
                                ))}
                              </FormikSelect>
                              {touched.nxtgnDepartment &&
                              errors.nxtgnDepartment ? (
                                <div className="error-label">
                                  {errors.nxtgnDepartment}
                                </div>
                              ) : null}
                            </Else>
                          </If>
                        </section>

                        <section className="form-row custom-form-row">
                          <CustomLabel required title="Select Date" />
                          <div className="date-picker">
                            <RangePicker
                              format="MM-DD-YYYY"
                              name="date"
                              placeholder={["Start Date", "End Date"]}
                              onChange={(value) => setFieldValue("date", value)}
                              onBlur={() => setFieldTouched("date", true)}
                              value={values.date}
                              disabled={!state.notConfigured && true}
                              className={`common-date-time ${
                                touched.date && errors.date ? "error-box" : ""
                              }`}
                              inputReadOnly={true}
                              disabledDate={
                                values.fileBasedSearchType ===
                                "Reminder Workflow"
                                  ? isDateDisabledForReminderWorkflow
                                  : undefined
                              }
                            />

                            {touched.date && errors.date ? (
                              <div className="error-label">{errors.date}</div>
                            ) : null}
                          </div>
                        </section>

                        {((state.ehrName &&
                          state.ehrName?.toLowerCase() !== EPIC_EHR) ||
                          values.fileBasedSearchType !== "API" ||
                          PRACTICE_EDITION_WHITELABEL) && (
                          <section className="form-row custom-form-row">
                            <CustomLabel title="Select Time" />

                            <div className="date-picker">
                              <TimePicker.RangePicker
                                name="time"
                                placeholder={["Start Time", "End Time"]}
                                onChange={(value) => {
                                  setFieldValue("time", value);
                                }}
                                onBlur={() => setFieldTouched("time", true)}
                                value={values.time}
                                disabled={!state.notConfigured}
                                className={`common-date-time ${
                                  touched.time && errors.time ? "error-box" : ""
                                }`}
                                format="HH:mm"
                                inputReadOnly={true}
                              />

                              {touched.time &&
                                errors.time && (
                                  <div className="error-label">
                                    {errors.time}
                                  </div>
                                )}
                            </div>
                          </section>
                        )}

                        {PRACTICE_EDITION_WHITELABEL && (
                          <section>
                            <section className="form-row custom-form-row">
                              <CustomLabel title="Status" />
                              <CheckboxSelect
                                disabled={!state.notConfigured && true}
                                data={formattedStatusList}
                                placeholder="Select Status"
                                customClass={
                                  touched.status && errors.status
                                    ? "error-box"
                                    : ""
                                }
                                name="status"
                                value={values.status}
                                onChange={(value) =>
                                  setFieldValue("status", value)
                                }
                                onBlur={() => setFieldTouched("status", true)}
                              />
                              {touched.status && errors.status ? (
                                <div className="error-label">
                                  {errors.status}
                                </div>
                              ) : null}
                            </section>
                          </section>
                        )}

                        {(PRACTICE_EDITION_WHITELABEL ||
                          values.fileBasedSearchType ===
                            "Reminder Workflow") && (
                          <section className="form-row custom-form-row">
                            <CustomLabel title="Provider" />
                            <CheckboxSelect
                              disabled={!state.notConfigured && true}
                              data={formattedProviderList}
                              placeholder="Select Provider"
                              customClass={
                                touched.providerList && errors.providerList
                                  ? "error-box"
                                  : ""
                              }
                              name="providerList"
                              value={values.providerList}
                              onChange={(value) =>
                                setFieldValue("providerList", value)
                              }
                              onBlur={() =>
                                setFieldTouched("providerList", true)
                              }
                            />
                            {touched.providerList && errors.providerList ? (
                              <div className="error-label">
                                {errors.providerList}
                              </div>
                            ) : null}
                          </section>
                        )}

                        {[NEXTGEN_EHR].includes(state.ehrName?.toLowerCase()) &&
                          values.fileBasedSearchType === "API" && (
                            <section className="form-row with-mutli-select custom-form-row">
                              <CustomInput
                                type="switch"
                                title="Select"
                                pretext="Providers"
                                posttext="Resources"
                                name="selectResources"
                                active={!!values.selectResources}
                                onChange={(rawValue) => {
                                  const value =
                                    rawValue === true || rawValue === "true";
                                  setFieldValue("selectResources", value);
                                  if (!value) {
                                    setFieldValue("resource", null);
                                  } else {
                                    resetProvider();
                                  }
                                }}
                              />
                            </section>
                          )}
                        {values.selectResources ? (
                          <section className="form-row with-mutli-select custom-form-row">
                            <SingleFormikSelect
                              data={formattedResourceList}
                              name="resource"
                              onChange={(value) => {
                                setFieldValue("resource", value);
                              }}
                              style={{ width: 310 }}
                              optionLabelProp="title"
                              optionValueProp="value"
                              placeholder="Search Resources"
                              title="Resource"
                              infiniteScroll
                              loadMoreData={fetchResources}
                              disabled={!state.notConfigured && true}
                            />
                          </section>
                        ) : state.ehrName?.toLowerCase() === NEXTGEN_EHR &&
                        values.fileBasedSearchType === "API" ? (
                          <section className="form-row">
                            <SingleFormikSelect
                              data={formattedProviderList}
                              name="provider"
                              onChange={(value) => {
                                setFieldValue("provider", value);
                                setFieldValue("providerId", value.value);
                              }}
                              style={{ width: 310 }}
                              optionLabelProp="title"
                              optionValueProp="value"
                              placeholder="Search Providers"
                              title="Provider"
                              infiniteScroll
                              loadMoreData={fetchProviders}
                              disabled={!state.notConfigured && true}
                              buttonComponent={ButtonComponent}
                            />
                          </section>
                        ) : (
                          (apiEhrs.includes(state.ehrName?.toLowerCase()) ||
                            values.fileBasedSearchType === "File Based") && (
                            <section className="form-row with-mutli-select custom-form-row">
                              <CustomLabel title="Provider" />
                              <FormikSelect
                                name="providerId"
                                className={`common-select-field ${
                                  touched.providerId && errors.providerId
                                    ? "error-box"
                                    : ""
                                }`}
                                placeholder="Select Provider"
                                style={{ width: 310 }}
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                disabled={!state.notConfigured && true}
                                onChange={(value) => {
                                  setFieldValue("providerId", value);
                                }}
                                allowClear={true}
                              >
                                {formattedProviderList &&
                                  formattedProviderList.map((item) => (
                                    <Option key={item.value} value={item.value}>
                                      {item.title}
                                    </Option>
                                  ))}
                              </FormikSelect>
                              {touched.providerId && errors.providerId ? (
                                <div className="error-label">
                                  {errors.providerId}
                                </div>
                              ) : null}
                            </section>
                          )
                        )}
                        {IS_NON_PROD && (
  <div className="outreach-settings-section">
    <CustomLabel title="Outreach Settings" />
    <Tooltip title="For use only in non prod env">
      <span className="outreach-toggle-info">{MultiLanguageInfoIcon}</span>
    </Tooltip>
    <div className="outreach-toggle-row">
      <Switch
        checked={state.isTwilioDisabled}
        onChange={handleTwilioDisabledToggle}
        className="outreach-toggle-switch"
      />
      <span className="outreach-toggle-label">Disable Twilio</span>
      <Tooltip title="Disables outbound Twilio messages for test scenarios.">
        <span className="outreach-toggle-info">{MultiLanguageInfoIcon}</span>
      </Tooltip>
    </div>
    <div className="outreach-toggle-row">
      <Switch
        checked={state.allowDuplicate}
        onChange={handleAllowDuplicateToggle}
        className="outreach-toggle-switch"
      />
      <span className="outreach-toggle-label">Allow Duplicate</span>
      <Tooltip title="Allows duplicate records to be included during outreach.">
        <span className="outreach-toggle-info">{MultiLanguageInfoIcon}</span>
      </Tooltip>
    </div>
  </div>
)}
                        <section className="form-row search-appointments-button ">
                          <section className="form-buttons hide-for-mob">
                            <CustomButton
                              htmlType="submit"
                              type="primary"
                              className={
                                !(isValid && dirty) ? "disable-button" : ""
                              }
                              disabled={!(isValid && dirty)}
                              title="Search Appointments"
                            />
                          </section>
                        </section>
                      </article>
                    </Form>
                  </div>
                  {current === 0 && (
                    <div className="bottom-bar">
                      <BottomBar
                        handleBackButton={backButtonClicked}
                        handleNextButton={() => handleSubmit(values)}
                        disabled={!(isValid && dirty)}
                      />
                    </div>
                  )}
                </>
              );
            }}
          </Formik>
        </>
      ) : (
        // step 2 => after search apointments is clicked
        !state.broadcastInitiated && (
          <BroadcastMessage
            loading={loading}
            headers={headers}
            data={data}
            showTable={showtable}
            fileName={state.fileName}
            fileId={state.fileId}
            broadcastMessage={broadcastMessage}
            onCancel={cancel}
            typeLabel="Appointment"
            hasCancel={true}
            fetchTableData={fetchTableData}
            getSuggestions={getSuggestions}
            count={count}
            getScheduledMsgData={getScheduledMsgData}
            showBroadcastResend={showBroadcastResend}
            handleParentLoading={handleParentLoading}
            current={current}
            nextPage={next}
            prevPage={prev}
            handleEmailTemplateData={props.handleEmailTemplateData}
            showCheckboxes={true}
            rowSelection={{
              columnTitle: (() => {
                const { allSelected, unselected } = state.selectionState;
                const selectedRows = getFlattenedSelected(state.selectionState);

                const allRowsSelected = allSelected && unselected.length === 0;
                const someRowsSelected =
                  !allRowsSelected && selectedRows.length > 0;

                return (
                  <Checkbox
                    disabled={loading}
                    checked={allRowsSelected}
                    onChange={() => {
                      setState((st) => {
                        if (st.selectionState.allSelected) {
                          return {
                            ...st,
                            selectionState: {
                              allSelected: false,
                              selected: {},
                              unselected: [],
                            },
                          };
                        }

                        return {
                          ...st,
                          selectionState: {
                            allSelected: true,
                            unselected: [],
                            selected: {
                              ...st.selectionState.selected,
                              [st.pageNo]: (st.fields || []).map((row) =>
                                rowKey(row),
                              ),
                            },
                          },
                        };
                      });
                    }}
                    indeterminate={someRowsSelected}
                  />
                );
              })(),
              selectedRowKeys: getFlattenedSelected(state.selectionState),
              renderCell: (_checked, record, index) => {
                const selectedRows = getFlattenedSelected(state.selectionState);
                const checked = selectedRows.includes(rowKey(record));

                return (
                  <Checkbox
                    checked={checked}
                    onChange={(e) => {
                      setState((st) => {
                        const key = rowKey(record);
                        const flatSelected = getFlattenedSelected(
                          st.selectionState,
                        );
                        const alreadyChecked = flatSelected.includes(key);

                        if (!alreadyChecked) {
                          const newSelected = {
                            ...st.selectionState.selected,
                            [st.pageNo]: [
                              ...(st.selectionState.selected[st.pageNo] || []),
                              key,
                            ],
                          };
                          const flatAfterAdd = getFlattenedSelected({
                            ...st.selectionState,
                            selected: newSelected,
                          });

                          return {
                            ...st,
                            selectionState: {
                              allSelected:
                                st.selectionState.allSelected ||
                                flatAfterAdd.length === st.count,
                              selected: newSelected,
                              unselected: st.selectionState.unselected.filter(
                                (x) => x !== key,
                              ),
                            },
                          };
                        }

                        const unselected = st.selectionState.allSelected
                          ? [...st.selectionState.unselected, key]
                          : [];

                        return {
                          ...st,
                          selectionState: {
                            allSelected: st.selectionState.allSelected
                              ? unselected.length !== count
                              : false,
                            selected: {
                              ...st.selectionState.selected,
                              [st.pageNo]: (
                                st.selectionState.selected[st.pageNo] || []
                              ).filter((x) => x !== key),
                            },
                            unselected,
                          },
                        };
                      });
                    }}
                  />
                );
              },
              type: "checkbox",
            }}
          />
        )
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  uploadBroadCastFile: bindActionCreators(
    uploadBroadCastFileNewAction,
    dispatch,
  ),
  broadCastMessage: bindActionCreators(broadCastMessageAction, dispatch),
  reviewBroadCastMessage: bindActionCreators(
    broadCastMessageReviewAction,
    dispatch,
  ),
  broadCastPatientList: bindActionCreators(
    broadCastPatientListAction,
    dispatch,
  ),
  removeBroadCastApiPatient: bindActionCreators(
    removeBroadCastApiPatientAction,
    dispatch,
  ),
  broadCastApiPatientList: bindActionCreators(
    broadCastApiPatientListAction,
    dispatch,
  ),
  broadCastProvidersList: bindActionCreators(
    broadCastProvidersListAction,
    dispatch,
  ),
  cancelMessage: bindActionCreators(cancelMessageAction, dispatch),
  setPopup: (data) => dispatch(setPopup(data)),
  noInternetAction: () => dispatch(NoInternetAction()),
});

const mapStateToProps = (state) => ({
  patients: state.patients,
  user: state.login.user,
  popupReducer: state.popupReducer,
  noInternet: state.noInternet,
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FilterBroadcast),
);
